import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";

import { shotamDatabase } from "../../firebase";
import { RANDOM_CODE_CHARS, RANDOM_CODE_LENGTH } from "../../constants";

export const sendCodeInDatabase = (pseudo, code) => {
  setDoc(doc(shotamDatabase, "players", code), {
    authCode: code,
    name: pseudo,
    nbTokens: 1,
    inUse: pseudo.length > 0,
  })
    .then(() => {
      console.log("Code sent");
    })
    .catch(() => {
      console.log("Code not sent");
    });
};

export const generateCode = (pseudo = "") => {
  let newCode = "";
  for (let i = 0; i < RANDOM_CODE_LENGTH; i++) {
    newCode +=
      RANDOM_CODE_CHARS[Math.trunc(Math.random() * RANDOM_CODE_CHARS.length)];
  }
  sendCodeInDatabase(pseudo, newCode);
  return newCode;
};

export type ResultType = {
  success: boolean;
  message: string;
};
export const bindPseudoToCode = async (pseudo, code): Promise<ResultType> => {
  const docRef = doc(shotamDatabase, "players", code);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    if (docSnap.get("inUse")) {
      return new Promise<ResultType>((resolve, reject) => {
        reject("Code déjà utilisé.");
      }).catch((e) => {
        console.log(e);
        return { success: false, message: e };
      });
    }
    return updateDoc(doc(shotamDatabase, "players", code), {
      name: pseudo,
      inUse: true,
    })
      .then(() => {
        console.log("Player name updated");
        return { success: true, message: "" };
      })
      .catch(() => {
        console.log("Failed to update name");
        return { success: false, message: "Echec de l'opération" };
      });
  } else
    return new Promise<ResultType>((resolve, reject) => {
      reject("Code invalide.");
    }).catch((e) => {
      console.log(e);
      return { success: false, message: e };
    });
};
